import { ColDef, RowDragEvent } from 'ag-grid-community';
import ItemTable from '../ItemTable';
import MobileItemTable from '../MobileItemTable/MobileItemTable';
import FaqQuestionCell from './cells/FaqQuestionCell';
import { BrandFaqInterface } from '../../types/BrandFaqInterface';

interface BrandFaqsTableProps {
  faqs: BrandFaqInterface[];
  isDesktop?: boolean;
  onEdit: (id: number) => void;
  onDelete: (id: number) => void;
  onDragEnd?: (event: RowDragEvent) => void;
}

const FaqAnswerCell = ({ value }: { value: string }) => (
  <span className="brand-faqs-table__text brand-faqs-table__answer">{value}</span>
);

const BrandFaqsTable = ({ faqs, isDesktop, onEdit, onDelete, onDragEnd }: BrandFaqsTableProps) => {
  const COLUMNS: ColDef[] = [
    {
      headerName: 'QUESTION',
      headerClass: 'name-header',
      valueGetter: (params) => ({
        id: params.data.id,
        question: params.data.question,
        draggable: !!isDesktop,
        onEdit,
        onDelete
      }),
      cellRenderer: FaqQuestionCell,
      minWidth: 320,
      sortable: false,
      suppressMovable: true,
      wrapText: true,
      autoHeight: true
    },
    {
      headerName: 'ANSWER',
      headerClass: 'custom-header',
      field: 'answer',
      cellRenderer: FaqAnswerCell,
      minWidth: 280,
      sortable: false,
      suppressMovable: true,
      wrapText: true,
      autoHeight: true
    }
  ];

  return isDesktop ? (
    <ItemTable
      className="brand-faqs-table"
      items={faqs}
      columns={COLUMNS}
      draggable
      onDragEnd={onDragEnd}
      rowHeight={84}
    />
  ) : (
    <div className="brand-faqs-table-mobile-container">
      <MobileItemTable items={faqs} columns={COLUMNS} draggable={false} rowHeight={84} />
    </div>
  );
};

export default BrandFaqsTable;
